import { createStore } from "vuex";
import Request from "@/modules/Request";
import Authenticate from "@/modules/Authenticate";

// ストレージからログイン状態を取得し、Vuexストアにセット
let auth = new Authenticate();
let request = new Request();

export default createStore({
  state: {
    isLogin: auth.isLogin(),
    isManager: auth.isManager(),
    loginName: auth.loginName(),
    isShopping: auth.getShopping(),
    isManager_J: auth.isManager_J(),

    showLayout: true,

    cartItems: [],

    treeIsClickMember:"",
  },
  mutations: {
    login(state) {
      state.isLogin = true;
      let requestParams = request.createParams("webMdlMemberInfo", "getMemberName", []);
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          state.loginName = data.MemberName;
          state.isManager = data.Manager;
          state.isManager_J = data.Manager_J;
          state.isShopping = auth.getShopping();
          auth.setManager(data.Manager);
          auth.setManager_J(data.Manager_J);
          auth.setLoginName(data.MemberName);
        });
    },

    logout(state) {
      // stateを削除
      state.isLogin = false;
      state.isManager = false;
      state.isManager_J = false;
      state.loginName = "";
    },

    // カートに追加した結果
    refreshCart(state, cartReset) {
      let postParams = [cartReset];
      let requestParams = request.createParams(
        "webMdlCart",
        "getCart",
        postParams
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.state.cartItems = data.cartItems;
        });
    },
    
    showLayout(state) {
      state.showLayout = true;
    },
    hideLayout(state) {
      state.showLayout = false;
    }
  },
});